import { createReducer } from '@reduxjs/toolkit';
import { setClients, setSelectedClient, logoutUser, storePermanentlyRemoved } from './actions';

const initialState = {
  clients: [],
  selectedClient: null,
  clientsLoaded: false,
};

export const clientsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setClients, (state, action) => {
      state.clients = action.payload;
      state.clientsLoaded = true;
    })
    .addCase(setSelectedClient, (state, action) => {
      state.selectedClient = action.payload;
    })
    .addCase(storePermanentlyRemoved, () => ({ ...initialState }))
    .addCase(logoutUser, () => {
      return initialState;
    });
});
